// extracted by mini-css-extract-plugin
export default {"container":"image-item_container__8v7m1","active":"image-item_active__2dSuM","inactive":"image-item_inactive__A+NrJ","vertical":"image-item_vertical__l4KJL"};